const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaStatus: [],
	listaTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'VEICULO_STATUS_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'VEICULO_STATUS_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'VEICULO_STATUS_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'VEICULO_STATUS_VIAGEM_LISTADO':
            return {
				...state,
				listaStatus: action.payload.data
			};

		case 'VEICULO_STATUS_TIPO_SELECT_LISTADO':
            return {
				...state,
				listaTipo: action.payload.data
			};

        default:
            return state;
    }
}
